module.exports = __webpack_public_path__ + "static/media/close.f18cec5a.svg";